"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.clamp = void 0;
const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
exports.clamp = clamp;
var _default = exports.default = clamp;